
import Vue from 'vue';
import iconMap from '@/assets/svg/icons/iconMap';
export default Vue.extend({
  props: {
    name: { type: String, required: true },
  },
  data() {
    return {};
  },
  computed: {
    dynamicIcon() {
      if (!this.name) {
        return null;
      }
      return iconMap[this.name as string];
    },
  },
});
